import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'primereact/button';
import UserInfo from '../../../shared/UserInfo/UserInfo';
import { ImplementationFor, arraySort, } from '../../../shared/utility';
import { chenthoorLandscapeLogo, apcologo, lightningHandLogo, shamalAzzourLogo, ministryLogo, newKuwaitLogo, boldArabicFont, securityStamp, securityPositionFalah, securitySignatureFalah, securityPositionAnezi, securitySignatureAnezi, securityPositionJaseer, securitySignatureJaseer } from '../../../shared/fontsAndBitImages';
import * as actions from '../../../store/actions/index';
import Messages from '../../../shared/UI/Messages/Messages';
import { Toast } from 'primereact/toast';
import axios from '../../../axios-url';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { DROPDOWN_CONFIG, PRODUCTION_PLANNING_ID } from '../../../shared/Config';
import moment from 'moment';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Fieldset } from 'primereact/fieldset';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { MultiSelect } from 'primereact/multiselect';
import AZNLogo from '../../../assets/images/AZN LOGO .jpg';
import Attachments from '../../../shared/UI/Attachments/Attachments';
import jsPDF from "jspdf";
import 'jspdf-autotable';
import lodash from 'lodash';


const Inputs = ({ field, metaData, onInputChange, type, ...props }) => {
    const Component = ImplementationFor[parseInt(field.fieldType)] || false;

    return Component && <Component
        {...field}
        {...props}
        name={field.fieldName}
        label={field.fieldDescription}
        placeholder={field.fieldDescription}
        onInputChange={onInputChange}
        dateFormat={field.dateFormat}
        view={field.view}
        metaData={Object.assign({}, metaData, { "TA Request Number": props.TARequestNumber })}
    /> || null;

};

const currencyList = [
    { "label": "INR", "value": "INR", "id": "INR" },
    { "label": "KWD", "value": "KWD", "id": "KWD" },
    { "label": "SAR", "value": "SAR", "id": "SAR" },
    { "label": "USD", "value": "USD", "id": "USD" },
    { "label": "AED", "value": "AED", "id": "AED" },
    { "label": "EUR", "value": "EUR", "id": "EUR" },
    { "label": "OMR", "value": "OMR", "id": "OMR" },
    { "label": "BHD", "value": "BHD", "id": "BHD" },
    { "label": "GBP", "value": "GBP", "id": "GBP" },
    { "label": "CAD", "value": "CAD", "id": "CAD" },
    { "label": "CHF", "value": "CHF", "id": "CHF" },
    { "label": "DZD", "value": "DZD", "id": "DZD" },
    { "label": "IQD", "value": "IQD", "id": "IQD" },
    { "label": "JOD", "value": "JOD", "id": "JOD" },
    { "label": "PKR", "value": "PKR", "id": "PKR" },
    { "label": "PHP", "value": "PHP", "id": "PHP" },
    { "label": "JPY", "value": "JPY", "id": "JPY" }];

class AddProductionPlanning extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: '',
            month: '',
            year: '',
            loading: true,
            process: [],
            initialData: {},
            progressStarted: false,
            payslipGenerated: false,
            stageSequence: 0,
            month: false,
            year: false,
            requestDate: moment(),
            requestedFor: false,
            DynamicSupervisor: false,
            dynamicSupervisorDisplay: false,
            DynamicSupervisorsList: [],
            requestId: false,
            popupType: 'submit',
            requestattachments: [],
            // ingredientId -> categoryId, built from the last CalculateRecipe response so the
            // Ingredient Detail PDF can group by the server's actual category.
            ingredientCategoryById: {},
        }
        this.handleContainer = this.handleContainer.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = (e, el) => {
        e.preventDefault();
        const { name, value } = e.target;

        const updatedProcess = this.state.process.filter((p, i) => i <= parseInt(this.state.stageSequence) + 1).map(stage => {
            // First pass: update the changed field
            let updatedStageField = stage.stage_Field.map(field =>
                Object.assign({}, { ...field }, { fieldValue: field.fieldName === name ? value : field.fieldValue })
            );

            // Second pass: check if we need to recalculate Installment Amount
            const changedField = updatedStageField.find(f => f.fieldName === name);

            if (changedField && (changedField.fieldDescription === 'Requested Amount' || changedField.fieldDescription === 'Number Of Installments')) {
                // Find all the fields we need
                const requestedAmountField = updatedStageField.find(f => f.fieldDescription === 'Requested Amount');
                const numberOfInstallmentsField = updatedStageField.find(f => f.fieldDescription === 'Number Of Installments');
                const installmentAmountField = updatedStageField.find(f => f.fieldDescription === 'Installment Amount');

                // Calculate if all fields exist and have valid values
                if (installmentAmountField && requestedAmountField && numberOfInstallmentsField) {
                    const requestedAmount = requestedAmountField.fieldValue;
                    const numberOfInstallments = numberOfInstallmentsField.fieldValue;

                    if (requestedAmount && numberOfInstallments && numberOfInstallments != 0) {
                        const installmentAmount = (parseFloat(requestedAmount) / parseFloat(numberOfInstallments)).toFixed(2);

                        // Update the installment amount field
                        updatedStageField = updatedStageField.map(field =>
                            field.fieldDescription === 'Installment Amount' ?
                                Object.assign({}, { ...field }, { fieldValue: installmentAmount }) :
                                field
                        );
                    }
                }
            }

            // Keep every "Issue From Store" in Ingredient Detail in sync with the header "From Store"
            if (changedField && this.isFromStoreField(changedField)) {
                updatedStageField = updatedStageField.map(field =>
                    this.isIssueFromStoreField(field) ?
                        Object.assign({}, { ...field }, { fieldValue: changedField.fieldValue }) :
                        field
                );
            }

            return Object.assign({}, { ...stage }, { stage_Field: updatedStageField });
        });

        this.setState({
            process: updatedProcess,
            payslipGenerated: false
        });
    }

    rowExpansionTemplate = (data) => {
        try {
            // let currency = currencyList.find(el => el.value == data.Original_Currency);
            // let currencyId = currency && currency.id || '';
            //     let currencyLabel = currency && currency.label || '';
            //    // let fml = dependantdata.find(ef => ef.value == data.familyMembers);


            return (
                <div className="p-grid p-fluid" style={{ padding: '2em 1em 1em 1em' }}>
                    <div className="p-col-12 p-md-12">
                        <div className="p-grid">

                            <div className="p-md-3">Date Of Expenditure: </div>
                            <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Expenditure_Date}</div>

                            {/* <div className="p-md-3">Family Members: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Description}</div> */}
                            {data.Family_Members &&
                                <><div className="p-md-3">Family Members: </div><div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Family_Members}</div></>
                            }

                            {/*                         <div className="p-md-3">Expense Sub Category:</div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Expense_Nature}</div>

                        <div className="p-md-3">Amount In Original Currency: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Hotel_Expense + ' ' + currencyId}</div>

                        <div className="p-md-3">Exchange Rate: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Transportation_Expense  + ' ' + currencyId}</div>

                        <div className="p-md-3">Amount(KWD)</div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Meals_Expense  + ' ' + currencyId}</div> */}

                            {/* <div className="p-md-3">Expense Sub Category:</div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Expense_Sub_Category}</div>

                        <div className="p-md-3">Amount In Original Currency: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Amount_in_Original_Currency + ' ' + currencyLabel}</div> */}

                            {/* <div className="p-md-3">Exchange Rate: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Exchange_Rate  + ' ' + currencyId}</div> */}

                            {/*                         <div className="p-md-3">Amount(KWD)</div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Meals_Expense  + ' ' + currencyId}</div>

                        <div className="p-md-3">Purchases Expense </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Purchases_Expense  + ' ' + currencyId}</div>

                        <div className="p-md-3">Other Expenses </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Other_Expenses  + ' ' + currencyId}</div>

                        <div className="p-md-3">Total Expenses: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Total_Expenses  + ' ' + currencyId}</div>

                        <div className="p-md-3">Original Currency: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{currencyLabel || data.Original_Currency || ''}</div> */}

                            <div className="p-md-3">Exchange Rate:  </div>
                            <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Exchange_Rate}</div>

                            <div className="p-md-3">Amount In KWD:  </div>
                            <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Amount_in_KWD}</div>
                        </div>
                    </div>
                </div>

            );
        }
        catch (error) {
            this.setState({ error: error })
        }
    }

    // In the Ingredient Detail container only the Issue From / Issue to Store columns are editable.
    isIngredientContainer = (containerField) => !!containerField && /ingredient/i.test(containerField.fieldDescription || '');
    isIngredientStoreColumn = (columnField) => /^issue\s*(from|to)\s*store$/i.test(String(columnField.fieldDescription || '').trim());
    isIngredientReadOnlyColumn = (containerField, columnField) => this.isIngredientContainer(containerField) && !this.isIngredientStoreColumn(columnField);

    containerCellTemplate = (rowData, columnField, disabled, containerField) => {
        const fieldInstance = (rowData.fields || []).find(f => f.fieldId === columnField.fieldId) || {};
        const metaData = this.props.metaData || {};
        const onInputChange = (e) => this.handleChange(e, fieldInstance);

        // The Ingredient Detail store columns stay editable even when flagged 'Display Only'.
        const forceEditable = this.isIngredientContainer(containerField) && this.isIngredientStoreColumn(columnField);

        if (!forceEditable && ((fieldInstance.fieldStatus || columnField.fieldStatus) === 'Display Only' || this.isIngredientReadOnlyColumn(containerField, columnField))) {
            const dropdownMatch = metaData[columnField.fieldDescription] && fieldInstance.fieldValue && metaData[columnField.fieldDescription].find(o => o.value === fieldInstance.fieldValue);
            const displayValue = (dropdownMatch && dropdownMatch.label) || (['7', '8'].includes(String(columnField.fieldType)) && fieldInstance.fieldValue && moment(fieldInstance.fieldValue).format('MM/DD/YYYY')) || fieldInstance.fieldValue || '';
            return <span>{displayValue}</span>;
        }

        switch (forceEditable ? '2' : String(columnField.fieldType)) {
            case '2':
                return <Dropdown name={fieldInstance.fieldName} value={fieldInstance.fieldValue} options={metaData[columnField.fieldDescription] || []} placeholder={columnField.fieldDescription} disabled={disabled} onChange={onInputChange} style={{ width: '100%' }} {...DROPDOWN_CONFIG} />;
            case '3':
                return <MultiSelect name={fieldInstance.fieldName} value={fieldInstance.fieldValue ? fieldInstance.fieldValue.split(',') : []} options={metaData[columnField.fieldDescription] || []} placeholder={columnField.fieldDescription} disabled={disabled} onChange={onInputChange} filter className="p-col-12" {...DROPDOWN_CONFIG} />;
            case '7':
            case '8':
                return <Calendar name={fieldInstance.fieldName} value={fieldInstance.fieldValue && new Date(moment.utc(fieldInstance.fieldValue)) || ''} dateFormat={columnField.dateFormat} disabled={disabled} onChange={onInputChange} style={{ width: '100%' }} readOnlyInput showIcon />;
            default:
                return <InputText name={fieldInstance.fieldName} value={fieldInstance.fieldValue || ''} placeholder={columnField.fieldDescription} disabled={disabled} onChange={onInputChange} style={{ width: '100%' }} />;
        }
    }

    containerActionTemplate = (rowData, field, rowCount) => {
        // Ingredient Detail rows are generated as 'Display Only' but must still be deletable, like Menu Item Detail rows.
        const isDisplayOnly = !this.isIngredientContainer(field) && (rowData.fields || []).some(f => f.fieldStatus === 'Display Only');
        if (isDisplayOnly) return null;
        return <Button icon="pi pi-trash" className="p-button-danger" disabled={rowCount <= 1} onClick={() => this.removeContainerRow(field, rowData.childRowNmbr)} />;
    }

    removeContainerRow = (field, childRowNmbr) => {
        const { process, stageSequence } = this.state;
        const updatedProcess = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, {
            stage_Field: stage.stage_Field.filter(el => !(el.parentFieldId === field.fieldName && el.childRowNmbr === childRowNmbr))
        }));
        this.setState({ process: updatedProcess });
    }

    setFieldValueUsingFieldId(inputFieldId, process, valueToBeSet) {
        try {
            const { stageSequence } = this.state;

            const updatedProcess = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, {
                stage_Field: stage
                    .stage_Field.map(field => {
                        return Object.assign({}, { ...field }, { fieldValue: field.fieldId === inputFieldId ? valueToBeSet : field.fieldValue })
                    })
            }))

            return updatedProcess
        }
        catch (error) {
            this.setState({ error: error })
        }
    }

    setFieldValueUsingFieldidrownum(inputFieldid, process, valueToBeSet, childRowNmbr) {

        try {
            const { stageSequence } = this.state;

            const updatedProcess = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, {
                stage_Field: stage
                    .stage_Field.map(field => {
                        return Object.assign({}, { ...field }, { fieldValue: field.fieldId === inputFieldid && field.childRowNmbr == childRowNmbr ? valueToBeSet : field.fieldValue })
                    })
            }))

            return updatedProcess
        }
        catch (error) {
            this.setState({ error: error })
        }
    }

    handleContainer = (field) => {
        try {
            this.setState({ loading: true, ifaddupdatepressed: 1 });
            const { process, stageSequence } = this.state;
            const { location } = this.props;

            let error = 0;
            const InitialValues = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {
                if (stageIndex === 0) {
                    const stageField = arraySort(stage.stage_Field, 'fieldSequence');
                    const containerGroup = lodash.mapValues(lodash.groupBy(stageField.filter(_ => _.parentFieldId === field.fieldName), 'childRowNmbr')) || [];
                    const fields = containerGroup && Object.keys(containerGroup).length > 0 && containerGroup[Object.keys(containerGroup).length - 1] || [];
                    if (fields && fields.length > 0) {
                        let count = stageField.length + 1;
                        let sequence = stageField.length + 1;
                        const newFields = fields.reduce((a, el) => {
                            const startIndex = el.fieldName.substring(0, 10);
                            a.push(Object.assign({}, { ...el }, {
                                fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}`, parentFieldId: field.fieldName, childRowNmbr: Object.keys(containerGroup).length.toString(), fieldValue: el.fieldType == 1 ? '' : null
                            }));
                            return a;
                        }, []);
                        return Object.assign({}, { ...stage }, { stage_Field: stage.stage_Field.concat(newFields) });
                    } else if (location && location.state && location.state.stagesequence === stageIndex) {
                        error = 1;
                        return stage;
                    }
                    else {
                        return stage;
                    }
                } else {
                    return stage;
                }
            });

            if (error) {
                this.setState({ loading: false });
                this.growl.show({ severity: 'error', summary: null, detail: 'please provide correct details' });
                return;
            }

            this.setState({ loading: false, process: InitialValues });
        }

        catch (error) {
            this.setState({ error: error, loading: false });
        }
    }

    // Header "From Store" dropdown (its description may also be the keyword name StorageLocation)
    isFromStoreField = f => f.parentFieldId === '000' && ['from store', 'storagelocation', 'storage location'].includes(String(f.fieldDescription || '').trim().toLowerCase());

    // Ingredient Detail "Issue From Store" column
    isIssueFromStoreField = f => f.parentFieldId !== '000' && /^issue\s*from\s*store$/i.test(String(f.fieldDescription || '').trim());

    findContainerField = (stageField, childFieldDescription) => {
        return stageField.find(f => f.fieldType === '9' && stageField.some(sf => sf.parentFieldId === f.fieldName && sf.fieldDescription === childFieldDescription));
    }

    buildContainerRowsFromItems = (containerField, items, valueResolver) => {
        const stage = this.state.process[0];
        const stageField = arraySort(stage.stage_Field, 'fieldSequence');
        const groups = lodash.groupBy(stageField.filter(f => f.parentFieldId === containerField.fieldName), 'childRowNmbr');
        const templateFields = groups[Object.keys(groups)[0]] || [];
        const rowItems = (items && items.length > 0) ? items : [{}];

        let count = stageField.length + 1;
        let sequence = stageField.length + 1;
        const newFields = rowItems.reduce((rows, item, rowIndex) => {
            templateFields.forEach(tf => {
                const startIndex = tf.fieldName.substring(0, 10);
                rows.push(Object.assign({}, { ...tf }, {
                    fieldName: `${startIndex}${count++}`,
                    fieldSequence: sequence++,
                    childRowNmbr: rowIndex.toString(),
                    fieldValue: valueResolver(tf.fieldDescription, item)
                }));
            });
            return rows;
        }, []);

        return this.state.process.map((s, idx) => idx === 0 ? Object.assign({}, { ...s }, {
            stage_Field: s.stage_Field.filter(f => f.parentFieldId !== containerField.fieldName).concat(newFields)
        }) : s);
    }

    isEmptyValue = (val) => val === null || val === undefined || (Array.isArray(val) ? val.length === 0 : String(val).trim() === '');

    generate = () => {
        // Generate validates only these fields.
        // 'Request For' is accepted as the alternate label of 'Requested For'.
        const generateRequiredFields = ['Requested For', 'Request Date', 'Plan Date', 'Work Instruction', 'Restaurant'];
        const normalize = s => String(s || '').trim().toLowerCase();
        const shownFields = this.state.process
            .filter((p, i) => i <= parseInt(this.state.stageSequence))
            .reduce((all, s) => all.concat(s.stage_Field || []), []);
        const missingRequired = generateRequiredFields.filter(label => {
            const el = shownFields.find(f => f.parentFieldId === '000' && f.fieldType !== '9' && (
                normalize(f.fieldDescription) === normalize(label) ||
                (label === 'Requested For' && normalize(f.fieldDescription) === 'request for')
            ));
            return el && this.isEmptyValue(el.fieldValue);
        });
        if (missingRequired.length > 0) {
            this.setState({ requiredFieldsMessage: `Please fill in the following required fields: ${missingRequired.join(', ')}.` });
            return;
        }

        const { loggedUserDetail } = this.props;
        const stage = this.state.process[0];
        const stageField = arraySort(stage.stage_Field, 'fieldSequence');

        // This page only has a single "Plan Date" field; it drives both ends of the forecast range.
        const planDateField = stageField.find(f => f.fieldDescription === 'Plan Date');
        const fromDateField = planDateField || stageField.find(f => f.fieldDescription === 'Planning From Date');
        const toDateField = planDateField || stageField.find(f => f.fieldDescription === 'Planning To Date');
        const restaurantField = stageField.find(f => f.fieldDescription === 'Restaurant');
        const menuContainerField = this.findContainerField(stageField, 'Menu Item');

        if (!fromDateField || !fromDateField.fieldValue) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Plan Date is required' });
            return;
        }
        if (!toDateField || !toDateField.fieldValue) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Plan Date is required' });
            return;
        }
        if (!restaurantField || !restaurantField.fieldValue) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Restaurant is required' });
            return;
        }
        if (!menuContainerField) return;

        const companyId = loggedUserDetail.CompanyId;
        // Keep the selected calendar date as-is: converting local midnight straight to UTC
        // shifts it back a day in timezones ahead of UTC (e.g. IST), so build the ISO string
        // from the local date at UTC midnight instead.
        const fromDate = moment.utc(moment(fromDateField.fieldValue).format('YYYY-MM-DD')).toISOString();
        const toDate = moment.utc(moment(toDateField.fieldValue).format('YYYY-MM-DD')).toISOString();

        this.setState({ loading: true });

        axios.post(`/master/api/res/GetMenuForecast?companyId=${companyId}&FromDate=${fromDate}&ToDate=${toDate}&OutLet=00000000-0000-0000-0000-000000000001`)
            .then(response => {
                const updatedProcess = this.buildContainerRowsFromItems(menuContainerField, response.data, (desc, item) => {
                    if (desc === 'Menu Item') return item.menuItemId;
                    if (desc === 'Quantity') return item.forecastQuantity;
                    if (desc === 'Unit') return item.uomId;
                    if (desc === 'Meal Type') return item.mealtypeId;
                    return null;
                });

                this.setState({ loading: false, process: updatedProcess });
                this.growl.show({ severity: 'success', summary: null, detail: 'Menu Forecast generated successfully' });
            })
            .catch(() => {
                this.setState({ loading: false });
                this.growl.show({ severity: 'error', summary: null, detail: 'Failed to generate menu forecast' });
            });
    }

    calculate = () => {
        const { loggedUserDetail } = this.props;
        const stage = this.state.process[0];
        const stageField = arraySort(stage.stage_Field, 'fieldSequence');

        const menuContainerField = this.findContainerField(stageField, 'Menu Item');
        const ingredientContainerField = this.findContainerField(stageField, 'Ingredient');
        const fromStoreField = stageField.find(this.isFromStoreField);

        if (!menuContainerField || !ingredientContainerField) return;

        const menuGroups = lodash.groupBy(stageField.filter(f => f.parentFieldId === menuContainerField.fieldName), 'childRowNmbr');
        // Calculate validates only these Menu Item Detail columns, across all rows.
        const missingMenuFields = ['Menu Item', 'Quantity', 'Unit'].filter(label =>
            Object.keys(menuGroups).some(key => {
                const el = menuGroups[key].find(f => f.fieldDescription === label);
                return el && this.isEmptyValue(el.fieldValue);
            })
        );
        if (missingMenuFields.length > 0) {
            this.setState({ requiredFieldsMessage: `Please fill in the following required fields: ${missingMenuFields.join(', ')}.` });
            return;
        }

        const norm = f => String(f.fieldDescription || '').trim().toLowerCase();
        let missingQty = false;
        const requestBody = Object.keys(menuGroups).reduce((rows, key) => {
            const rowFields = menuGroups[key];
            const itemField = rowFields.find(f => norm(f) === 'menu item') || rowFields.find(f => /menu|item|product/.test(norm(f)) && !/qty|quantity|unit/.test(norm(f)));
            const qtyField = rowFields.find(f => norm(f) === 'quantity') || rowFields.find(f => /qty|quantity/.test(norm(f)));
            const hasItem = itemField && itemField.fieldValue != null && String(itemField.fieldValue).trim() !== '';
            const qty = qtyField ? parseFloat(qtyField.fieldValue) : NaN;
            if (hasItem && !isNaN(qty) && qty > 0) {
                rows.push({ menuItemId: itemField.fieldValue, qty });
            } else if (hasItem) {
                missingQty = true;
            }
            return rows;
        }, []);

        if (requestBody.length === 0) {
            this.growl.show({ severity: 'error', summary: null, detail: missingQty ? 'Please enter a Quantity greater than 0 for the menu item' : 'Please select a Menu Item' });
            return;
        }

        const companyId = loggedUserDetail.CompanyId;

        this.setState({ loading: true });

        axios.post(`/master/api/res/CalculateRecipe?companyId=${companyId}`, requestBody)
            .then(response => {
                const updatedProcess = this.buildContainerRowsFromItems(ingredientContainerField, response.data, (desc, item) => {
                    if (desc === 'Ingredient') return item.ingredientId;
                    if (desc === 'Quantity') return item.requiredQuantity;
                    if (desc === 'Unit') return item.uomId;
                    if (/^issue\s*from\s*store$/i.test(String(desc || '').trim())) return fromStoreField ? fromStoreField.fieldValue : null;
                    return null;
                });

                const ingredientCategoryById = (response.data || []).reduce((map, item) => {
                    if (item && item.ingredientId) map[item.ingredientId] = item.categoryId;
                    return map;
                }, { ...this.state.ingredientCategoryById });

                this.setState({ loading: false, process: updatedProcess, ingredientCategoryById });
                this.growl.show({ severity: 'success', summary: null, detail: 'Recipe calculated successfully' });
            })
            .catch(() => {
                this.setState({ loading: false });
                this.growl.show({ severity: 'error', summary: null, detail: 'Failed to calculate recipe' });
            });
    }

    // Returns the currently displayed Ingredient Detail rows (each a sorted array of
    // that row's fields), skipping fully empty rows.
    getIngredientDetailRows = () => {
        const { process } = this.state;
        const rows = [];

        (process || []).forEach(stage => {
            const stageFields = stage.stage_Field || [];
            const containerField = stageFields.find(f => f.fieldType === '9' && /ingredient/i.test(f.fieldDescription || ''));
            if (!containerField) return;

            const childFields = stageFields.filter(f => f.parentFieldId === containerField.fieldName);
            const grouped = lodash.groupBy(childFields, 'childRowNmbr');

            Object.keys(grouped).forEach(rowKey => {
                const rowFields = arraySort(grouped[rowKey], 'fieldSequence');
                const hasData = rowFields.some(f => f.fieldValue != null && String(f.fieldValue).trim() !== '');
                if (hasData) rows.push(rowFields);
            });
        });

        return rows;
    }

    // Resolves a row's Category (Grocery / Veg / Reuse) from the categoryId returned by CalculateRecipe,
    // looked up in the ingCategory dropdown list.
    getIngredientRowCategory = (rowFields) => {
        const { ingredientCategoryList = [] } = this.props;
        const ingredientField = rowFields.find(f => f.fieldDescription === 'Ingredient');
        const ingredientId = ingredientField && ingredientField.fieldValue;
        const categoryId = ingredientId && this.state.ingredientCategoryById[ingredientId];
        const categoryEntry = categoryId && ingredientCategoryList.find(c => String(c.value) === String(categoryId) || String(c.id) === String(categoryId));

        return (categoryEntry && categoryEntry.label) || 'Others';
    }

    // Groups the currently displayed Ingredient Detail rows by Category.
    groupIngredientRowsByCategory = () => {
        const rows = this.getIngredientDetailRows();

        const grouped = {};

        rows.forEach(rowFields => {
            const category = this.getIngredientRowCategory(rowFields);
            if (!grouped[category]) {
                grouped[category] = {
                    columns: rowFields.map(f => f.fieldDescription),
                    rows: []
                };
            }
            grouped[category].rows.push(rowFields.map(f => this.resolveFieldDisplayValue(f)));
        });

        return grouped;
    }

    // Generates one PDF per represented Category using the Ingredient Detail rows currently shown,
    // with a branded header/footer repeated on every page.
    // Downscales the (very large) logo once so it isn't embedded at full resolution in every PDF.
    getCompressedLogo = () => new Promise(resolve => {
        const img = new Image();
        img.onload = () => {
            try {
                const width = 400;
                const canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = Math.round(width * img.height / img.width);
                canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
                resolve(canvas.toDataURL('image/png'));
            } catch (e) {
                resolve(chenthoorLandscapeLogo);
            }
        };
        img.onerror = () => resolve(chenthoorLandscapeLogo);
        img.src = chenthoorLandscapeLogo;
    });

    generateIngredientDetailPdf = async () => {
        try {
            const logoData = await this.getCompressedLogo();
            const { loggedUserDetail } = this.props;
            const categoryGroups = this.groupIngredientRowsByCategory();
            const categories = Object.keys(categoryGroups);

            if (categories.length === 0) {
                this.growl.show({ severity: 'error', summary: null, detail: 'No Ingredient Detail data to export' });
                return;
            }

            // const printedBy = (loggedUserDetail && (loggedUserDetail.userName || loggedUserDetail.empID)) || '';
            const printedBy = String(
                (this.props.userPosInfo && this.props.userPosInfo.userName)
                || (loggedUserDetail && loggedUserDetail.userName)
                || ''
            ).trim();
            const printedOn = moment().format('DD/MM/YYYY HH:mm');

            const BRAND_COLOR = [30, 41, 59];      // header banner / table head background
            const BAND_COLOR = [244, 246, 249];    // zebra stripe for body rows
            const BORDER_COLOR = [210, 214, 220];  // table + rule lines
            const MUTED_TEXT = [110, 118, 128];

            const ACCENT_COLOR = [196, 154, 60];   // gold accent line / markers
            const HEADER_HEIGHT = 58;
            const FOOTER_HEIGHT = 16;

            categories.forEach(category => {
                const { columns, rows } = categoryGroups[category];
                const doc = new jsPDF('p', 'mm', 'a4', 3);
                const pageWidth = doc.internal.pageSize.getWidth();
                const pageHeight = doc.internal.pageSize.getHeight();

                const columnStyles = columns.reduce((styles, col, idx) => {
                    if (/quantity|qty|amount/i.test(col)) {
                        styles[idx] = { halign: 'right' };
                    }
                    return styles;
                }, {});

                const drawHeaderAndFooter = (data) => {
                    // ---- Header banner ----
                    // Soft tinted backdrop with a solid brand bar across the top edge
                    doc.setFillColor(...BAND_COLOR);
                    doc.rect(0, 0, pageWidth, HEADER_HEIGHT - 12, 'F');
                    doc.setFillColor(...BRAND_COLOR);
                    doc.rect(0, 0, pageWidth, 3, 'F');
                    doc.setFillColor(...ACCENT_COLOR);
                    doc.rect(0, 3, pageWidth, 0.8, 'F');

                    doc.addImage(logoData, 'PNG', (pageWidth - 34) / 2, 8, 34, 18, 'chenthoorLandscapeLogo', 'FAST');

                    doc.setTextColor(...BRAND_COLOR);
                    doc.setFont('helvetica', 'bold');
                    doc.setFontSize(16);
                    doc.text('Ingredient Requirement Report', pageWidth / 2, 33, { align: 'center' });

                    // Short accent divider under the title
                    doc.setDrawColor(...ACCENT_COLOR);
                    doc.setLineWidth(0.8);
                    doc.line(pageWidth / 2 - 14, 36, pageWidth / 2 + 14, 36);
                    doc.setLineWidth(0.2);

                    doc.setFont('helvetica', 'bold');
                    doc.setFontSize(8.5);
                    doc.setTextColor(...MUTED_TEXT);
                    doc.text('CHENTHOOR RESTAURANT', pageWidth / 2, 41, { align: 'center' });
                    doc.setFont('helvetica', 'normal');
                    doc.setFontSize(8);
                    doc.text(`Generated: ${printedOn}`, pageWidth / 2, 45, { align: 'center' });

                    // ---- Category title strip ----
                    doc.setFillColor(...BAND_COLOR);
                    doc.setDrawColor(...BORDER_COLOR);
                    doc.rect(10, HEADER_HEIGHT - 8, pageWidth - 20, 8, 'FD');
                    doc.setFillColor(...ACCENT_COLOR);
                    doc.rect(10, HEADER_HEIGHT - 8, 1.6, 8, 'F');
                    doc.setTextColor(...BRAND_COLOR);
                    doc.setFont('helvetica', 'bold');
                    doc.setFontSize(11);
                    doc.text(`${category} - Ingredient List`, 14, HEADER_HEIGHT - 2.7);
                    doc.setFont('helvetica', 'normal');
                    doc.setFontSize(9);
                    doc.setTextColor(...MUTED_TEXT);
                    doc.text(`Total Items: ${rows.length}`, pageWidth - 13, HEADER_HEIGHT - 2.7, { align: 'right' });

                    // ---- Footer ----
                    doc.setDrawColor(...BORDER_COLOR);
                    doc.line(10, pageHeight - FOOTER_HEIGHT, pageWidth - 10, pageHeight - FOOTER_HEIGHT);
                    doc.setFont('helvetica', 'normal');
                    doc.setFontSize(8);
                    doc.setTextColor(...MUTED_TEXT);
                    doc.text(`Printed By: ${printedBy}     Printed On: ${printedOn}`, 10, pageHeight - FOOTER_HEIGHT + 6);
                    doc.text(`Page ${data.pageNumber}`, pageWidth - 10, pageHeight - FOOTER_HEIGHT + 6, { align: 'right' });
                };

                doc.autoTable({
                    theme: 'grid',
                    startY: HEADER_HEIGHT + 4,
                    margin: { top: HEADER_HEIGHT + 4, left: 10, right: 10, bottom: FOOTER_HEIGHT + 2 },
                    styles: { fontSize: 9, cellPadding: 3.2, lineColor: BORDER_COLOR, lineWidth: 0.1, textColor: [45, 45, 45], halign: 'center', valign: 'middle' },
                    headStyles: { fillColor: BRAND_COLOR, textColor: [255, 255, 255], fontStyle: 'bold', fontSize: 9.5, halign: 'center' },
                    alternateRowStyles: { fillColor: BAND_COLOR },
                    columnStyles,
                    head: [columns],
                    body: rows,
                    didDrawPage: drawHeaderAndFooter,
                });

                doc.save(`${category}_IngredientRequirement.pdf`);
            });
        } catch (error) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Failed to generate Ingredient Detail PDF' });
        }
    }

    handleAttachment = (data, type) => {
        let index = 0;
        let attachmentData = data.map((el) => {
            index++
            return {
                Requestattachmentid: '00000000-0000-0000-0000-000000000000',
                Requestid: '00000000-0000-0000-0000-000000000000',
                SiNo: index,
                UploadPath: el.filePath,
                FileName: el.fileName,
                Extension: el.fileExtension,
                Createdby: this.props.loggedUserDetail.empID,
                Createddate: moment().format('MM/DD/YYYY'),
                Updatedby: this.props.loggedUserDetail.empID,
                Updateddate: moment().format('MM/DD/YYYY'),
                CompanyId: this.props.loggedUserDetail.CompanyId,
                Stagenum: 0,
            }
        });
        this.setState({ requestattachments: attachmentData });
    }

    initialize = (process, type, field) => {
        const { tableLists, location = {} } = this.props;
        const { stageSequence } = this.state;
        const status = (location.state && location.state.editStatus) || (tableLists && Object.keys(tableLists).length > 0 && tableLists.status) || false;
        const pageType = this.props.match.params.type;
        const pendingWith = location && location.state && location.state.pendingWith


        let count = 1;
        let sequence = 1;
        if (type === 'progress' || type === 'add' || type === 'edit') {
            this.setState({ process: [], loading: true });

            const InitialValues = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {
                const stageField = arraySort(stage.stage_Field, 'fieldSequence');
                return Object.assign({}, { ...stage }, {
                    stage_Field: stageField.reduce((a, el) => {
                        const startIndex = el.fieldName.substring(0, 10);
                        if (type === 'add' && el.parentFieldId === '000' && el.fieldType != '9') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                        } else if (type === 'add' && el.fieldType === '9') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            const fields = stageField.filter(_ => _.parentFieldId === el.fieldName);
                            const lastItem = a[a.length - 1];
                            fields.map((subField) => {
                                a.push(Object.assign({}, { ...subField }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}`, parentFieldId: lastItem.fieldName, childRowNmbr: '0' }));
                            })
                        } else if (type === 'edit') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stage_FieldsList: [], disabled: (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            const lastItem = a[a.length - 1];
                            if (el.stage_FieldsList && el.stage_FieldsList.length > 0) {
                                el.stage_FieldsList.map((subField, subIndex) => {
                                    if (subIndex != 0) {
                                        subField.stage_FieldsListc2.map(c2 => {
                                            a.push(Object.assign({}, { ...c2 }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, disabled: (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false, stageSequence: stageIndex, stageNum: `00${stageIndex}`, parentFieldId: lastItem.fieldName }));
                                        })
                                    }
                                })
                            }
                        }
                        return a;
                    }, [])
                })
            });

            setTimeout(() => this.setState({ loading: false, process: InitialValues }), 3000);
        } else {

            this.growl.show({ severity: 'error', summary: null, detail: 'please provide correct details' });
        }

    }


    generatePayslip = (type) => {
        let process = this.state.process;
        const { containerData, location = {}, } = this.props;
        const { state = {} } = location;
        let requestId = state.requestId
        this.setState({ loading: true });

        axios.get('/master/api/Employee/GetFinalapprover?RequestId=' + requestId)
            .then((response) => {
                if (response.status === 200) {
                    let empId = response.data.toUpperCase();
                    this.handlePayslipInPdf(type, empId);
                }
            }).catch((error) => {
                this.growl.show({ severity: 'error', summary: null, detail: 'Final Approver API Error, please try again' });
                this.setState({ loading: false });
            })

    }


    // Resolves ID/value to its corresponding Label for PDF display.
    resolveFieldDisplayValue = (field) => {
        const { metaData = {} } = this.props;

        if (!field) {
            return '';
        }

        const fieldValue = field.fieldValue;

        if (fieldValue == null || fieldValue === '') {
            return '';
        }

        const options = metaData[field.fieldDescription] || [];

        const matchedOption = options.find(option => {
            if (!option) return false;
            return (
                String(option.value != null ? option.value : '').toLowerCase() === String(fieldValue).toLowerCase() ||
                String(option.id != null ? option.id : '').toLowerCase() === String(fieldValue).toLowerCase() ||
                String(option.uniqueId != null ? option.uniqueId : '').toLowerCase() === String(fieldValue).toLowerCase()
            );
        });

        if (matchedOption) {
            return matchedOption.label || matchedOption.text || matchedOption.name || fieldValue;
        }

        // Date fields
        if (field.fieldType === '7' || field.fieldType === '8') {
            return moment(fieldValue).format('DD/MM/YYYY');
        }

        return fieldValue;
    };

    resolveEmployeeLabel = (employeeId) => {
        if (employeeId == null || employeeId === '') {
            return '';
        }

        const {
            metaData = {},
            loggedUserDetail = {},
            Employee = []
        } = this.props;

        const employeeOptions = [
            ...(metaData['Request For'] || []),
            ...(metaData['Requested For'] || []),
            ...(Employee || [])
        ];

        const employee = employeeOptions.find(option => {
            if (!option) return false;

            return (
                String(option.value || '').toLowerCase() === String(employeeId).toLowerCase() ||
                String(option.id || '').toLowerCase() === String(employeeId).toLowerCase() ||
                String(option.uniqueId || '').toLowerCase() === String(employeeId).toLowerCase()
            );
        });

        if (employee) {
            return (
                employee.label ||
                employee.text ||
                employee.name ||
                employee.userName ||
                employee.employeeName ||
                employeeId
            );
        }

        if (
            loggedUserDetail.empID &&
            String(loggedUserDetail.empID).toLowerCase() === String(employeeId).toLowerCase()
        ) {
            return loggedUserDetail.userName || employeeId;
        }

        return employeeId;
    };

    handlePayslipInPdf = (type, empId) => {
        try {
            const { process } = this.state;
            const { location = {}, tableLists = {}, loggedUserDetail = {}, containerData } = this.props;
            const { state = {} } = location;

            // Full stage list (reached stages + any stages not yet reached/approved), same
            // concat convention already used by this component's own polling logic, so
            // pending stages are included instead of being structurally absent from `process`.
            // const templateStages = (containerData && Object.keys(containerData).length > 0 && containerData.stage) || [];
            // const fullProcess = (process.length > 0 && process.concat(templateStages.filter((c, i) => i > (process.length - 1)))) || process;

            const templateStages =
                (
                    containerData &&
                    Object.keys(containerData).length > 0 &&
                    Array.isArray(containerData.stage)
                )
                    ? containerData.stage
                    : [];

            const savedProcess =
                (
                    tableLists &&
                    Array.isArray(tableLists.requestAttribute1) &&
                    tableLists.requestAttribute1.length > 0
                )
                    ? tableLists.requestAttribute1
                    : (
                        Array.isArray(process)
                            ? process
                            : []
                    );

            const fullProcess =
                savedProcess.length > 0
                    ? savedProcess.concat(
                        templateStages.filter(
                            (stage, index) => index >= savedProcess.length
                        )
                    )
                    : templateStages;
            // Header fields: top-level (non-container) fields across every completed stage
            // (Planning From Date, Planning To Date, Restaurant, etc.), deduped by fieldDescription
            // so the same field repeated across stages contributes only one column.
            const headerFieldsMap = new Map();
            process.forEach(stage => {
                (stage.stage_Field || [])
                    .filter(field => field.parentFieldId === '000' && field.fieldType !== '9')
                    .forEach(field => {
                        headerFieldsMap.set(field.fieldDescription, field);
                    });
            });
            const headerFields = Array.from(headerFieldsMap.values());

            // Line items: fieldType '9' containers (Menu Item Detail, Ingredient Detail), grouped by
            // childRowNmbr, each rendered under its own heading/container - same pattern as the
            // Item / Service Charges containers in AddPurchaseReturn.
            const lineItemSections = [];

            const getSectionTitle = (containerField) => {
                const description = (containerField.fieldDescription || '').trim();

                if (/menu\s*item/i.test(description)) {
                    return 'Menu Item Detail';
                }

                if (/ingredient/i.test(description)) {
                    return 'Ingredient Detail';
                }

                return description;
            };

            const hasRowData = (rowFields = []) => {
                return rowFields.some(field => {
                    const value = field && field.fieldValue;

                    if (value === null || value === undefined) {
                        return false;
                    }

                    if (Array.isArray(value)) {
                        return value.length > 0;
                    }

                    return String(value).trim() !== '';
                });
            };

            process.forEach(stage => {
                const stageFields = stage.stage_Field || [];

                const containerFields = stageFields.filter(
                    field => field.fieldType === '9'
                );

                containerFields.forEach(containerField => {
                    const sectionTitle = getSectionTitle(containerField);

                    if (
                        sectionTitle !== 'Menu Item Detail' &&
                        sectionTitle !== 'Ingredient Detail'
                    ) {
                        return;
                    }

                    const childFields = stageFields.filter(
                        field => field.parentFieldId === containerField.fieldName
                    );

                    if (childFields.length === 0) {
                        return;
                    }

                    const groupedRows = lodash.groupBy(
                        childFields,
                        field => field.childRowNmbr
                    );

                    const rowKeys = Object.keys(groupedRows);

                    const validRowKeys = rowKeys.filter(rowKey => hasRowData(groupedRows[rowKey]));

                    const firstValidRow =
                        validRowKeys.length > 0
                            ? groupedRows[validRowKeys[0]]
                            : childFields;

                    const uniqueColumns = [];

                    firstValidRow.forEach(field => {
                        const columnName = field.fieldDescription;

                        if (columnName && !uniqueColumns.includes(columnName)) {
                            uniqueColumns.push(columnName);
                        }
                    });

                    let section = lineItemSections.find(item => item.title === sectionTitle);

                    if (!section) {
                        section = {
                            title: sectionTitle,
                            columns: uniqueColumns,
                            rows: []
                        };

                        lineItemSections.push(section);
                    }

                    validRowKeys.forEach(rowKey => {
                        const rowFields = groupedRows[rowKey];

                        const rowData = section.columns.map(columnName => {
                            const field = rowFields.find(rowField => rowField.fieldDescription === columnName);

                            if (!field) {
                                return '';
                            }

                            return this.resolveFieldDisplayValue(field);
                        });

                        if (rowData.some(value => value !== null && value !== undefined && String(value).trim() !== '')) {
                            section.rows.push(rowData);
                        }
                    });
                });
            });

            // Force the required section order so both containers always render, even when empty.
            const requiredSectionOrder = ['Menu Item Detail', 'Ingredient Detail'];

            const orderedLineItemSections = [];

            requiredSectionOrder.forEach(sectionName => {
                const existingSection = lineItemSections.find(section => section.title === sectionName);

                if (existingSection) {
                    orderedLineItemSections.push(existingSection);
                } else {
                    orderedLineItemSections.push({
                        title: sectionName,
                        columns: [],
                        rows: []
                    });
                }
            });

            lineItemSections.length = 0;
            orderedLineItemSections.forEach(section => {
                lineItemSections.push(section);
            });

            // Approval History: parsed from each subsequent stage's description (skips the initial/request stage),
            // same extraction logic as the existing approval-history PDF sections elsewhere in the app.
            // =========================
            // Approval History
            // =========================

            const processArray = fullProcess.slice(1);
            const approvalHistoryRows = [];

            processArray.forEach((item, index) => {

                let employeeNumber = '';
                let employeeName = '';
                let position = '';
                let dateAndTime = 'Pending';

                const templateStage = templateStages[index + 1];

                // Saved stage description
                const itemDescription =
                    item &&
                        item.description !== null &&
                        item.description !== undefined
                        ? String(item.description).trim()
                        : '';

                // Template stage description
                const templateDescription =
                    templateStage &&
                        templateStage.description !== null &&
                        templateStage.description !== undefined
                        ? String(templateStage.description).trim()
                        : '';

                /*
                 * Approved stage:
                 * Use saved stage description first.
                 *
                 * Pending stage:
                 * Use template stage description.
                 */
                const description = itemDescription || templateDescription;

                console.log(
                    'APPROVAL HISTORY STAGE',
                    index + 1,
                    {
                        item: item,
                        itemDescription: itemDescription,
                        templateDescription: templateDescription,
                        description: description
                    }
                );

                if (description) {

                    // Expected:
                    // Approved By: 1000,
                    // PMT MOHAMED ABOOBACKER - DIRECTOR,
                    // DIRECTOR,
                    // Date & Time: 13/09/2026 10:30

                    const parts = description
                        .split(',')
                        .map(part => part.trim());

                    if (parts.length >= 1) {
                        employeeNumber = (parts[0] || '')
                            .replace(/^[^:]+:\s*/, '')
                            .trim();
                    }

                    if (parts.length >= 2) {
                        employeeName = (parts[1] || '')
                            .split('-')[0]
                            .trim();
                    }

                    if (parts.length >= 3) {
                        position = (parts[2] || '')
                            .replace(/^[^:]+:\s*/, '')
                            .trim();
                    }

                    if (parts.length >= 4) {
                        const parsedDateAndTime = (parts[3] || '')
                            .replace(/^[^:]+:\s*/, '')
                            .trim();

                        if (
                            parsedDateAndTime &&
                            !/^pending$/i.test(parsedDateAndTime) &&
                            !/^approval$/i.test(parsedDateAndTime)
                        ) {
                            dateAndTime = parsedDateAndTime;
                        }
                    }
                }

                /*
                 * If approval is completed but description does not contain
                 * employee information, try to use stage-level employee fields.
                 */
                if (!employeeNumber && item) {
                    employeeNumber =
                        item.employeeNumber ||
                        item.EmployeeNumber ||
                        item.employeeNo ||
                        item.EmployeeNo ||
                        item.empNo ||
                        item.EmpNo ||
                        '';
                }

                if (!employeeName && item) {
                    employeeName =
                        item.employeeName ||
                        item.EmployeeName ||
                        item.empName ||
                        item.EmpName ||
                        '';
                }

                if (!position && item) {
                    position =
                        item.position ||
                        item.Position ||
                        item.designation ||
                        item.Designation ||
                        '';
                }

                /*
                 * Date & Time fallback
                 */
                if (dateAndTime === 'Pending' && item) {

                    const approvalDate =
                        item.approvalDate ||
                        item.ApprovalDate ||
                        item.approvedDate ||
                        item.ApprovedDate ||
                        item.approvalDateTime ||
                        item.ApprovalDateTime ||
                        item.approvedDateTime ||
                        item.ApprovedDateTime ||
                        item.dateAndTime ||
                        item.DateAndTime ||
                        '';

                    if (approvalDate) {
                        dateAndTime = approvalDate;
                    }
                }

                approvalHistoryRows.push([
                    index + 1,
                    employeeNumber,
                    employeeName,
                    position,
                    dateAndTime
                ]);
            });

            const requestNum = state.requestNum || (tableLists && tableLists.requestNum) || 'ProductionPlanning';

            // Request For: convert Employee ID to Employee Label/Name - same lookup used below for
            // the "Request For" header column, so Created By always matches that displayed name.
            const requestedForField = headerFields.find(
                field =>
                    field.fieldDescription === 'Requested For' ||
                    field.fieldDescription === 'Request For'
            );

            const requestedFor = requestedForField
                ? this.resolveEmployeeLabel(requestedForField.fieldValue)
                : (empId ? this.resolveEmployeeLabel(empId) : '');

            // Created By must always match the Request For name shown elsewhere in the PDF.
            const createdBy = requestedFor;
            // const printedBy = (loggedUserDetail && (loggedUserDetail.userName || loggedUserDetail.empID)) || '';
            const printedBy = String(
                (this.props.userPosInfo && this.props.userPosInfo.userName)
                || (loggedUserDetail && loggedUserDetail.userName)
                || ''
            ).trim();
            const printedOn = moment().format('DD/MM/YYYY HH:mm');

            const headerColumns = ['Request Num', ...headerFields.map(field => field.fieldDescription)];

            const headerValues = [
                requestNum,
                ...headerFields.map(field => {
                    if (
                        field.fieldDescription === 'Request For' ||
                        field.fieldDescription === 'Requested For'
                    ) {
                        return this.resolveEmployeeLabel(field.fieldValue);
                    }

                    return this.resolveFieldDisplayValue(field);
                })
            ];

            var doc = new jsPDF('p', 'mm', 'a4', 3);

            doc.autoTable({
                theme: 'plain',
                didDrawCell: function (data) {
                    if (data.column.index === 0 && data.cell.section === 'body') {
                        doc.addImage(chenthoorLandscapeLogo, 'PNG', data.cell.x, data.cell.y - 3, 40, 20);
                    }
                },
                startY: 9,
                margin: { left: 8.5 },
                columnStyles: { 0: { cellWidth: 50 }, 1: { cellWidth: 200 } },
                body: [[
                    { content: "", styles: { cellPadding: 0, borderColor: 'white' } },
                    { content: "CHENTHOOR RESTAURANT", styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fontSize: 14, textColor: 'black', cellPadding: { top: 5, left: 6, right: 0 }, borderColor: 'white' } }
                ]]
            });

            let previousTableEnding = doc.lastAutoTable.finalY;

            doc.autoTable({
                theme: 'grid',
                startY: previousTableEnding + 10,
                margin: { left: 5 },
                tableWidth: 200,
                body: [[]]
            });

            previousTableEnding = doc.lastAutoTable.finalY;

            doc.setFontSize(12);
            doc.text('Production Planning Details:', 5, previousTableEnding + 14);

            const headerMidpoint = Math.ceil(headerColumns.length / 2);
            const headerColumnsRow1 = headerColumns.slice(0, headerMidpoint);
            const headerValuesRow1 = headerValues.slice(0, headerMidpoint);
            const headerColumnsRow2 = headerColumns.slice(headerMidpoint);
            const headerValuesRow2 = headerValues.slice(headerMidpoint);

            doc.autoTable({
                theme: 'grid',
                startY: previousTableEnding + 18,
                styles: { halign: 'center', fontSize: 8, cellPadding: 3 },
                headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                bodyStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                alternateRowStyles: { fillColor: [255, 255, 255] },
                tableLineColor: [0, 0, 0],
                tableLineWidth: 0.1,
                margin: { left: 5 },
                tableWidth: 200,
                head: [headerColumnsRow1],
                body: [headerValuesRow1],
            });

            previousTableEnding = doc.lastAutoTable.finalY;

            if (headerColumnsRow2.length > 0) {
                doc.autoTable({
                    theme: 'grid',
                    startY: previousTableEnding,
                    styles: { halign: 'center', fontSize: 8, cellPadding: 3 },
                    headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                    bodyStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                    alternateRowStyles: { fillColor: [255, 255, 255] },
                    tableLineColor: [0, 0, 0],
                    tableLineWidth: 0.1,
                    margin: { left: 5 },
                    tableWidth: 200,
                    head: [headerColumnsRow2],
                    body: [headerValuesRow2],
                });

                previousTableEnding = doc.lastAutoTable.finalY;
            }

            lineItemSections.forEach(section => {
                doc.setFontSize(12);
                doc.text(`${section.title}:`, 5, previousTableEnding + 14);

                if (!section.columns || section.columns.length === 0) {
                    doc.autoTable({
                        theme: 'grid',
                        startY: previousTableEnding + 18,
                        margin: { left: 5 },
                        tableWidth: 200,
                        styles: { halign: 'center', fontSize: 8, cellPadding: 3 },
                        headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                        bodyStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                        tableLineColor: [0, 0, 0],
                        tableLineWidth: 0.1,
                        body: [[{ content: 'No records found', colSpan: 1, styles: { halign: 'center' } }]]
                    });
                } else {
                    doc.autoTable({
                        theme: 'grid',
                        startY: previousTableEnding + 18,
                        styles: { halign: 'center', fontSize: 8, cellPadding: 3 },
                        headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                        bodyStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                        alternateRowStyles: { fillColor: [255, 255, 255] },
                        tableLineColor: [0, 0, 0],
                        tableLineWidth: 0.1,
                        margin: { left: 5 },
                        tableWidth: 200,
                        head: [section.columns],
                        body: section.rows.length > 0 ? section.rows : [section.columns.map(() => '')]
                    });
                }

                previousTableEnding = doc.lastAutoTable.finalY;
            });

            if (approvalHistoryRows.length > 0) {
                doc.setFontSize(12);
                doc.text('Approval History:', 5, previousTableEnding + 14);
                doc.autoTable({
                    theme: 'grid',
                    startY: previousTableEnding + 18,
                    styles: { halign: 'center', fontSize: 8, cellPadding: 3 },
                    headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                    bodyStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                    alternateRowStyles: { fillColor: [255, 255, 255] },
                    tableLineColor: [0, 0, 0],
                    tableLineWidth: 0.1,
                    margin: { left: 5 },
                    tableWidth: 200,
                    head: [['S.No', 'Employee Number', 'Employee Name', 'Position', 'Date & Time']],
                    body: approvalHistoryRows,
                });
                previousTableEnding = doc.lastAutoTable.finalY;
            }

            const totalPages = doc.internal.getNumberOfPages();
            for (let pageIndex = 1; pageIndex <= totalPages; pageIndex++) {
                doc.setPage(pageIndex);
                doc.setFontSize(8);
                doc.setTextColor(0, 0, 0);
                doc.text(`Created By: ${createdBy}     Printed By: ${printedBy}     Printed On: ${printedOn}`, 5, 292);
            }

            if (type === 'print') {
                doc.autoPrint();
                window.open(doc.output('bloburl'), requestNum);
                this.setState({ loading: false, payslipGenerated: true });
            } else if (type === 'view') {
                window.open(doc.output('bloburl'), requestNum);
                this.setState({ loading: false, payslipGenerated: true });
            } else if (type === 'download') {
                doc.save(`${requestNum}.pdf`);
                this.setState({ loading: false, payslipGenerated: true });
            }
        } catch (error) {
            this.setState({ loading: false });
            this.growl.show({ severity: 'error', summary: null, detail: 'Failed to generate PDF' });
        }
    }

    saveRequest = (submitType) => {
        const { containerData } = this.props;
        const { process } = this.state;
        const type = this.props.match.params.type;
        let requestNumber = (this.props.location && this.props.location.state && this.props.location.state.requestNum) || '';
        let loggedUserEmpId = this.props.loggedUserDetail.empID;


        let RequestAttributes = [];
        let Comment = '';
        process.map((stage, stageIndex) => {
            stage.stage_Field.map(el => {

                //         if (el.fieldDescription === 'Comment' && stageIndex === 0) {
                //             Comment = el.fieldValue;
                //         }
                //         if(el.fieldDescription === 'Expense Type' && stageIndex === 0){
                //             RequestType = el.fieldValue;
                //         }

                RequestAttributes.push(Object.assign({}, { ...el }, { fieldValue: (el.fieldType === "7" || el.fieldType === "8") ? moment(el.fieldValue).format('MM/DD/YYYY') : el.fieldValue }));
            })
        });

        if (submitType === 'save' || submitType === 'submit') {
            const missingFields = [];
            // Only stages shown on screen (same filter the render uses)
            process.filter((p, i) => i <= parseInt(this.state.stageSequence)).forEach(stage => {
                (stage.stage_Field || []).forEach(el => {
                    if (el.fieldStatus !== 'Required' || el.parentFieldId !== '000' || el.fieldType === '9') {
                        return;
                    }
                    // Only validate fields that are actually rendered on the form (same check Inputs uses)
                    if (!el.fieldDescription || !ImplementationFor[parseInt(el.fieldType)]) {
                        return;
                    }
                    if (this.isEmptyValue(el.fieldValue) && !missingFields.includes(el.fieldDescription)) {
                        missingFields.push(el.fieldDescription);
                    }
                });
            });

            // Ingredient Detail columns that must not be empty in any row.
            // Matched with the same tolerant regex used by the grid (case / spacing insensitive).
            const ingredientColumns = ['Issue From Store', 'Issue To Store'];
            const ingredientColumnLabel = f => {
                const m = /^issue\s*(from|to)\s*store$/i.exec(String(f.fieldDescription || '').trim());
                return m ? `Issue ${m[1].toLowerCase() === 'from' ? 'From' : 'To'} Store` : null;
            };
            const missingIngredientFields = [];
            process.filter((p, i) => i <= parseInt(this.state.stageSequence)).forEach(stage => {
                const stageFields = stage.stage_Field || [];
                const containerField = stageFields.find(f => f.fieldType === '9' && /ingredient/i.test(f.fieldDescription || ''));
                if (!containerField) return;

                stageFields.filter(f => f.parentFieldId === containerField.fieldName && ingredientColumnLabel(f)).forEach(el => {
                    const label = ingredientColumnLabel(el);
                    if (this.isEmptyValue(el.fieldValue) && !missingIngredientFields.includes(label)) {
                        missingIngredientFields.push(label);
                    }
                });
            });
            // Keep the popup's field order the same as the column order.
            const orderedIngredientFields = ingredientColumns.filter(label => missingIngredientFields.includes(label));

            // Containers without at least one saved row (the last child row is the input row, not a saved one)
            const emptyContainers = [];
            process.filter((p, i) => i <= parseInt(this.state.stageSequence)).forEach(stage => {
                (stage.stage_Field || []).filter(el => el.fieldType === '9' && el.parentFieldId === '000').forEach(container => {
                    const grouped = lodash.groupBy((stage.stage_Field || []).filter(_ => _.parentFieldId === container.fieldName), 'childRowNmbr');
                    const rowKeys = Object.keys(grouped);
                    if (rowKeys.length === 0 || rowKeys.length > 1) {
                        return;
                    }
                    const requiredNames = [];
                    arraySort(grouped[rowKeys[0]], 'fieldSequence').forEach(sub => {
                        if (sub.fieldStatus !== 'Required' || !sub.fieldDescription || !ImplementationFor[parseInt(sub.fieldType)]) {
                            return;
                        }
                        if (!requiredNames.includes(sub.fieldDescription)) {
                            requiredNames.push(sub.fieldDescription);
                        }
                    });
                    if (requiredNames.length > 0) {
                        emptyContainers.push({ name: container.fieldDescription, fields: requiredNames });
                    }
                });
            });

            if (missingFields.length > 0 || orderedIngredientFields.length > 0 || emptyContainers.length > 0) {
                const lines = [];
                if (missingFields.length > 0) {
                    lines.push(`Please fill in the following required fields: ${missingFields.join(', ')}.`);
                }
                if (emptyContainers.length > 0) {
                    lines.push('Please add at least one row with the following required fields in each container:');
                }
                this.setState({
                    requiredFieldsMessage: lines.join('\n'),
                    requiredIngredientFields: orderedIngredientFields,
                    requiredFieldsContainers: emptyContainers
                });
                return;
            }
        }

        let data = {
            FromDate: moment().format('MM/DD/YYYY'),
            ToDate: moment().format('MM/DD/YYYY'),
            VisaCount: 0,
            TicketCount: 0,
            RequestDesc: 'Employee Loan Request',
            IsActive: true,
            RequestDate: moment().format('MM/DD/YYYY'),
            EmpID: this.props.loggedUserDetail.empID,
            LoginEmployeeID: this.props.loggedUserDetail.empID,
            CompanyID: this.props.loggedUserDetail.CompanyId,
            Remark: Comment,
            RequestedFor: this.props.loggedUserDetail.empID,
            ProcessID: PRODUCTION_PLANNING_ID,
            RequestAttributes: RequestAttributes,
            Requestattachments: this.state.requestattachments,
            Requestforms: [],
            Requestactions: [],
            stagesequence: this.state.stageSequence,
            processNum: containerData.processNum
        };


        if (process && process.length > 0) {

            let model = 'requestSave';
            if (submitType === 'submit') {
                if (this.state.DynamicSupervisor) {
                    data.DynamicSupervisor = this.state.DynamicSupervisor;
                }

                model = 'RPP';
            }

            if (submitType === 'delegate') {
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Delegate_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                model = 'RPP';
            }

            if (submitType === 'forward') {
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Forward_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                model = 'RPP';
            }

            if (submitType === 'return' && this.state.DynamicSupervisor) {
                const SelDropdownEmployee = this.state.DynamicSupervisorsList.find(el => el.value === this.state.DynamicSupervisor);
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Return_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                data.Return_to_WF_Level_ID = SelDropdownEmployee && Object.keys(SelDropdownEmployee).length > 0 && SelDropdownEmployee.Request_WF_LEVEL_ID;
                model = 'RPP';
            }


            if (type === 'edit' && this.state.requestId) {
                data.requestId = this.state.requestId
            }

            var stringifyData = JSON.stringify(data);
            var datas = { Key: stringifyData };

            let url = (type === 'edit') ? '/master/api/UpdateDynamicData?model=' + model : '/master/api/InsertDynamicData?model=' + model;

            if (submitType === 'submit') {
                url = '/master/api/workflow/submit?type=' + model;
            } else if (submitType === 'reject') {
                url = '/master/api/workflow/reject?type=' + model;
            } else if (submitType === 'delegate') {
                url = '/master/api/workflow/delegate?type=' + model;
            } else if (submitType === 'forward') {
                url = '/master/api/workflow/forward?type=' + model;
            } else if (submitType === 'return') {
                url = '/master/api/workflow/return?type=' + model;
            } else if (submitType === 'cancel') {
                url = '/master/api/workflow/cancel?type=' + model;
            }

            this.setState({ loading: true });

            // if(requestNumber && submitType == 'submit'){//checking whether the request is in the requester stage or approver stage
            //     let generatedPdf = this.handlePayslipInPdf('upload', loggedUserEmpId.toUpperCase());
            //     axios.post(`/master/api/Base4ToPDF`, generatedPdf)
            //         .then(response => {
            //             if(response.status == 200){
            //                 axios.post(url, JSON.stringify(datas))// triggering the submit/save of a request
            //                     .then(response => {
            //                         this.setState({ loading: false });
            //                         if (submitType === 'submit' || submitType === 'return') {
            //                             if (response.status === 200) {
            //                                 if (response.data.id !== undefined && response.data.id === 'DYNAMIC') {
            //                                     let submitValue = response.data.result && JSON.parse(response.data.result);
            //                                     let tableValue = [];
            //                                     if (submitValue.Table && submitValue.Table !== undefined && submitValue.Table.length > 0) {
            //                                         tableValue = submitValue.Table.map(list => {
            //                                             return { label: list.NAME, value: list.EMPLOYEE_ID, id: list.EMPLOYEE_NO ,Request_WF_LEVEL_ID: list.Request_WF_LEVEL_ID}
            //                                         })
            //                                     }
            //                                     if(submitType === 'submit'){
            //                                         this.setState({dialogBoxText: "Select Supervisor"})
            //                                     }
            //                                     if(submitType === 'return'){
            //                                         this.setState({dialogBoxText: "Return To", popupType:'return'})
            //                                     }
            //                                     this.setState({ requestId: response.data.requestId, dynamicSupervisorDisplay: true, DynamicSupervisorsList: tableValue })
            //                                 } else {
            //                                     this.growl.show({ severity: 'success', summary: null, detail: 'Visitor Gate-Pass Request submitted successfully' });
            //                                     this.props.history.push('/dashboard');
            //                                 }
            //                             } else {
            //                                 this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
            //                             }

            //                         } else {
            //                             this.growl.show({ severity: 'success', summary: null, detail: 'Visitor Gate-Pass Request saved successfully' });
            //                             this.props.history.push('/dashboard');
            //                         }

            //                     })
            //                     .catch(err => {
            //                         this.setState({ loading: false })
            //                         this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
            //                     })
            //             }

            //         }).catch(err => {
            //             this.growl.show({ severity: 'error', summary: null, detail: 'File Upload API Failed. Please Approve again' });
            //             this.setState({ loading: false });
            //         })
            // } else 
            {
                axios.post(url, JSON.stringify(datas))
                    .then(response => {

                        this.setState({ loading: false });
                        if (submitType === 'submit' || submitType === 'return') {
                            if (response.status === 200) {
                                if (response.data.id !== undefined && response.data.id === 'DYNAMIC') {
                                    let submitValue = response.data.result && JSON.parse(response.data.result);
                                    let tableValue = [];
                                    if (submitValue.Table && submitValue.Table !== undefined && submitValue.Table.length > 0) {
                                        tableValue = submitValue.Table.map(list => {
                                            return { label: list.NAME, value: list.EMPLOYEE_ID, id: list.EMPLOYEE_NO, Request_WF_LEVEL_ID: list.Request_WF_LEVEL_ID }
                                        })
                                    }
                                    if (submitType === 'submit') {
                                        this.setState({ dialogBoxText: "Select Supervisor" })
                                    }
                                    if (submitType === 'return') {
                                        this.setState({ dialogBoxText: "Return To", popupType: 'return' })
                                    }
                                    this.setState({ requestId: response.data.requestId, dynamicSupervisorDisplay: true, DynamicSupervisorsList: tableValue })
                                } else {
                                    this.growl.show({ severity: 'success', summary: null, detail: 'Employee Loan Request submitted successfully' });
                                    this.props.history.push('/dashboard');
                                }
                            } else {
                                this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
                            }

                        } else {
                            this.growl.show({ severity: 'success', summary: null, detail: 'Employee Loan Request saved successfully' });
                            this.props.history.push('/dashboard');
                        }

                    })
                    .catch(err => {
                        this.setState({ loading: false })
                        this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
                    })
            }

        }

    }

    componentDidMount() {
        const { getContainerData, getKeywordValues, getMasterKeywordList, location = {}, loggedUserDetail } = this.props;
        const type = this.props.match.params.type;
        // this.effectiveDateHandler()
        // getContainerData("B1F0B0EC-DF1D-414B-BD09-9AED7F0BA1BB");//Get Container Data
        if (type === 'add') {
            getContainerData(PRODUCTION_PLANNING_ID);//Get Container Data
        }

        getMasterKeywordList('Employee');//Get Employee
        getMasterKeywordList('MenuItem');//Get Nationality Dropdown list 
        getMasterKeywordList('UOM');
        getMasterKeywordList('Ingredient');//Get Loan Type Dropdown list
        getMasterKeywordList('ingCategory');//Grocery / Veg / Reuse list, used to resolve CalculateRecipe's categoryId for the Ingredient Detail PDFs
        getMasterKeywordList('Branch');//Get Deduction Frequency Dropdown list
        getMasterKeywordList('StorageLocation');//Get Deduction Frequency Dropdown list
        getMasterKeywordList('resMealPeriod');//Get Deduction Frequency Dropdown list
        if (type === 'edit') {
            this.props.getRequestAttributeData(this.props.match.params.id);
        }

        const clearTimer = () => clearInterval(interval);
        const interval = setInterval(() => {
            const stageSequence = (location.state && location.state.stagesequence) || this.state.stageSequence;
            const requestId = this.props.match.params.id || this.state.requestId;
            const { tableLists, containerData } = this.props;
            const type = this.props.match.params.type;
            let requestattachments = tableLists.requestattachments || [];
            this.setState({ requestattachments });

            const container = containerData && Object.keys(containerData).length > 0 && containerData.stage || [];
            let process = containerData && Object.keys(containerData).length > 0 && containerData.stage || false;
            if (type === 'edit') {
                process = tableLists && Object.keys(tableLists).length > 0 && tableLists.requestAttribute1 || false;
            }

            if (process && !this.props.loading) {
                this.setState({ stageSequence, requestId, initialData: type === 'edit' && process.length > 0 && process.concat(container.filter(((c, i) => i > (process.length - 1)))) || process });
                setTimeout(() => this.initialize(type === 'edit' && process.length > 0 && process.concat(container.filter(((c, i) => i > (process.length - 1)))) || process, type === 'edit' ? 'edit' : 'add'), 3000);
                clearTimer();
            }
        }, 300);

    }


    render() {
        const { tableLists, location = {}, metaData = {} } = this.props;
        const { state = {} } = location;
        const { process, stageSequence, currentSequence } = this.state;
        const pendingWith = location && location.state && location.state.pendingWith;
        const actionRowStyle = { display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center' };

        const pageType = this.props.match.params.type;
        const status = (location.state && location.state.editStatus) || (tableLists && Object.keys(tableLists).length > 0 && tableLists.status) || false;
        const dialogDynamicFooter = (
            <div style={actionRowStyle}>
                <Button icon="pi pi-times" onClick={() => this.setState({ dynamicSupervisorDisplay: false, DynamicSupervisor: null, DynamicSupervisorsList: null })} label="Close" className="p-button-secondary" />
                <Button onClick={() => this.saveRequest(this.state.popupType || 'submit')} icon="pi pi-check" disabled={(this.state.DynamicSupervisor === null)} label="Submit" className="p-button-primary" />
            </div>
        );
        let a;
        {
            a = process.filter((p, i) => i <= parseInt(stageSequence));
        }


        return (

            <div className="p-grid leaverequest">
                {(this.props.loading || this.state.loading) && <div className="page-loader"></div>}
                {(this.props.error !== null || this.state.error) && <Messages type="error" message={this.props.error || this.state.error} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>
                            Production Planning
                            <Link to={'/ProductionPlanning'}>
                                <Button style={{ float: 'right' }} label="Back" icon="pi pi-arrow-left" className="ml1 p-button-secondary" />
                            </Link>
                        </h1>
                        <UserInfo userObject={this.props.userPosInfo} requestNum={state.requestNum} />
                    </div>
                </div>



                {process.filter((p, i) => i <= parseInt(stageSequence)).map((stage, stageIndex) => {
                    const { stage_Field, description } = stage;
                    const stageField = arraySort(stage_Field, 'fieldSequence');

                    return <div key={stageIndex} className="p-col-12">
                        <div className="card card-w-title">
                            <h1>{description}</h1>
                            <div className="p-grid">
                                {(stageField || []).map((field, fieldIndex) => {
                                    const containerGroup = field.fieldType === '9' && lodash.mapValues(lodash.groupBy(stageField.filter(_ => _.parentFieldId === field.fieldName), 'childRowNmbr')) || false;
                                    const containerColumns = (containerGroup && Object.values(containerGroup).reduce((best, grp) => grp.length > best.length ? grp : best, [])) || [];
                                    const containerRows = (containerGroup && Object.keys(containerGroup).length > 0 && Object.keys(containerGroup).map(row => ({
                                        childRowNmbr: row,
                                        parentFieldId: field.fieldName,
                                        fields: containerGroup[row]
                                    }))) || [];
                                    const containerActionsDisabled = (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false;

                                    return field.parentFieldId === "000" ? <React.Fragment key={fieldIndex}>
                                        <div className={field.fieldType === "9" || field.fieldType === "6" ? "p-col-12" : "p-col-12 p-md-6 p-lg-4"}>
                                            {field.fieldType != "9" ? <Inputs
                                                field={Object.assign({}, { ...field }, { disabled: field.fieldDescription === 'Installment Amount' ? true : field.disabled, dateFormat: (field.fieldDescription === 'Repayment Start Month' || field.fieldDescription === 'Repayment End Month') ? 'mm/yy' : undefined, view: (field.fieldDescription === 'Repayment Start Month' || field.fieldDescription === 'Repayment End Month') ? 'month' : undefined })}
                                                value={field.fieldType === '3' && field.fieldValue ? field.fieldValue.split(",") : field.fieldValue}
                                                process={process}
                                                onInputChange={(e) => this.handleChange(e, field)}
                                                {...this.props}
                                                {...this.state} /> :
                                                field.fieldType === '9' ?
                                                    <Fieldset legend={field.fieldDescription} toggleable collapsed={this.state[field.fieldName] === undefined ? true : this.state[field.fieldName]} onToggle={(e) => this.setState({ [field.fieldName]: e.value })} style={{ border: this.state[field.fieldName] === undefined || this.state[field.fieldName] ? 'none' : '1px solid rgba(0, 0, 0, 0.38)' }}>
                                                        <div className="p-grid">
                                                            <div className="p-col-12" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                                <Button disabled={containerActionsDisabled} className="p-button-success" icon="pi pi-plus" onClick={() => this.handleContainer(field)} label="Add Row" />
                                                            </div>
                                                            <div className="p-col-12">
                                                                <DataTable className="animated fadeInLeft" rowHover emptyMessage="No records found..." responsive={true}
                                                                    dataKey="childRowNmbr" rows={10} value={containerRows}>
                                                                    {containerColumns.map((columnField, columnIndex) =>
                                                                        <Column key={columnIndex} header={columnField.fieldDescription} body={(rowData) => this.containerCellTemplate(rowData, columnField, containerActionsDisabled, field)} />
                                                                    )}
                                                                    {
                                                                        containerActionsDisabled ? null : <Column body={(rowData) => this.containerActionTemplate(rowData, field, containerRows.length)} header="Action" style={{ textAlign: 'center', width: '8em' }} />
                                                                    }
                                                                </DataTable>
                                                            </div>
                                                            {field.fieldDescription === 'Menu Item Detail' && <div className="p-col-12" style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                                                                <Button disabled={containerActionsDisabled} className="p-button-secondary" icon="pi pi-calculator" onClick={this.calculate} label="Calculate" />
                                                            </div>}
                                                            {/ingredient/i.test(field.fieldDescription || '') && <div className="p-col-12" style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '10px' }}>
                                                                <Button className="p-button-success" icon="pi pi-file-pdf" onClick={this.generateIngredientDetailPdf} label="PDF" />
                                                            </div>}
                                                        </div>
                                                    </Fieldset> : null}
                                        </div>
                                        {field.fieldDescription === 'Restaurant' && field.fieldType !== '9' ? <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label">&nbsp;</label>
                                            <div className="mt1">
                                                <Button label="Generate" icon="pi pi-refresh" className="p-button-secondary" style={{ width: '100%' }} disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={this.generate} />
                                            </div>
                                        </div> : null}
                                    </React.Fragment> : null

                                })}


                                {/* {( stage.stageNum == '000' || stage.stageSequence == 0)  ? 
                                <div className="p-col-12 p-md-12 p-lg-12">
                                     <Attachments 
                                     handleAttachment = {this.handleAttachment} 
                                     folderName = 'VisitorPass'
                                     reloadedValues = {this.state.requestattachments}
                                     isReloaded = {(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false}
                                     /> 
                                </div> 
                                    :
                                 null} */}

                                {stageIndex > 0 ?
                                    <div className="p-col-12 p-md-12 p-lg-12" style={actionRowStyle}>
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('submit')} className="p-button-success" label="Approve" icon="pi pi-save" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Reject" onClick={() => this.saveRequest('reject')} className="p-button-danger" />
                                        {/* <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Return" onClick={() => this.saveRequest('return')} className="p-button-warning ml1" /> */}
                                        {/* <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Forward" onClick={() => this.handleMethods('forward')} className="ml1" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Delegate" onClick={() => this.handleMethods('delegate')} className="p-button-info ml1" /> */}
                                        {/* <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('save')} className="p-button-secondary ml1" label="Save" icon="pi pi-save" /> */}
                                        <Link to={'/materialpass-in'}>
                                            <Button className="p-button-secondary" label="Close" icon="pi pi-times" />
                                        </Link>
                                    </div> :

                                    <div className="p-col-12 p-md-12 p-lg-12" style={actionRowStyle}>
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('save')} className="p-button-secondary" label="Save" icon="pi pi-save" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('submit')} className="p-button-success" label="Submit" icon="pi pi-save" />
                                        <Button disabled={status && status === 'Closed' && pendingWith === 'Closed' ? false : true} className="p-button-danger" label="Cancel" onClick={() => this.saveRequest('cancel')} />
                                        {/* <Button onClick={() => this.generatePayslip('view')} className="p-button-success ml1" label="View Payslip" icon="pi pi-save" /> */}
                                        {/* <Button /*disabled={this.state.payslipGenerated == false? true : false} onClick={() => this.setState({ payslipDisplay: true})} className="p-button-success ml1" label="View Payslip" icon="pi pi-save" /> */}
                                        {/* {((status && status === 'Closed') && (pendingWith && pendingWith === 'Closed')) ? <Button disabled={this.state.payslipGenerated == false? true : false} onClick={() => this.generatePayslip('download')} className="p-button-success ml1" label="Download Loan Request as PDF" icon="pi pi-save" /> : null} */}
                                        {/* {((status && status === 'Closed') && (pendingWith && pendingWith === 'Closed')) ? */}
                                        {/* // <Button disabled={this.state.payslipGenerated == false? true : false} onClick={() => this.generatePayslip('print')} className="p-button-success ml1" label="Print Loan Request" icon="pi pi-save" />: null} */}
                                        <Button onClick={() => this.generatePayslip('download')} className="p-button-success" label="Download PDF" icon="pi pi-file-pdf" />
                                        <Link to={'/EmployeeLoan'}>
                                            <Button className="p-button-secondary" label="Close" icon="pi pi-times" />
                                        </Link>
                                    </div>}
                            </div>
                        </div>
                    </div>
                })}


                <Dialog header="Required Fields" visible={!!this.state.requiredFieldsMessage || (this.state.requiredIngredientFields || []).length > 0} modal={true} style={{ width: '400px' }} closable={true}
                    footer={<Button label="Close" icon="pi pi-times" className="p-button-secondary" onClick={() => this.setState({ requiredFieldsMessage: '', requiredIngredientFields: [], requiredFieldsContainers: [] })} />}
                    onHide={() => this.setState({ requiredFieldsMessage: '', requiredIngredientFields: [], requiredFieldsContainers: [] })}>
                    {this.state.requiredFieldsMessage ? <p style={{ whiteSpace: 'pre-line', fontWeight: 'normal' }}>{this.state.requiredFieldsMessage}</p> : null}
                    {(this.state.requiredFieldsContainers || []).map((c, i) => (
                        <p key={i} style={{ margin: '0.25em 0', fontWeight: 'normal' }}><span style={{ fontWeight: 'bold' }}>{c.name}</span>: <span style={{ fontWeight: 'normal' }}>{c.fields.join(', ')}</span></p>
                    ))}
                    {(this.state.requiredIngredientFields || []).length > 0 ? <div>
                        <h3 style={{ margin: '0 0 8px' }}>Ingredient Details</h3>
                        <ol style={{ margin: 0, paddingLeft: '20px' }}>
                            {this.state.requiredIngredientFields.map(label => <li key={label}>{label}</li>)}
                        </ol>
                    </div> : null}
                </Dialog>

                <Dialog header={this.state.dialogBoxText} visible={this.state.dynamicSupervisorDisplay} modal={true} width="400px" footer={dialogDynamicFooter} onHide={() => this.setState({ dynamicSupervisorDisplay: false })}>
                    <div className="p-grid">
                        <div className="p-col-12 p-lg-12">
                            <label className="label">{this.state.dialogBoxText}<span className="requiredColor">*</span></label>
                            <div className="mt1">
                                <Dropdown placeholder={this.state.dialogBoxText} name="DynamicSupervisor" value={this.state.DynamicSupervisor} options={this.state.DynamicSupervisorsList} onChange={(e) => this.setState({ DynamicSupervisor: e.target.value })}   {...DROPDOWN_CONFIG} style={{ width: '100%' }} />
                            </div>
                        </div>
                    </div>
                </Dialog>

            </div>

        );
    }







}

const mapStateToProps = state => {
    const Employee = (state.keyword.Employee !== undefined) ? state.keyword.Employee : [];
    const ingredientCategoryList = state.keyword.ingCategory || [];
    const loggedUserDetail = state.auth.userObject || {};
    const subordinatesListData = state.master.subordinatesListData;
    const keywordValuesList = state.master.keywordValuesList.reduce((a, el) => {
        if (el.uniqueId !== state.auth.userObject.empID) {
            a.push(Object.assign({}, { ...el }, { value: el.uniqueId }));
        }
        return a;
    }, [Object.assign({}, state.master.keywordValuesList.find(list => list.uniqueId === state.auth.userObject.empID), { label: `${state.auth.userObject.userName}-Self`, value: state.auth.userObject.empID, id: parseInt(state.auth.userObject.userID) })]);

    let relevantOptions = [];
    let countryList = state.master.Country || [];
    const hrTeam = parseInt(localStorage.getItem('hrTeam'));
    if (hrTeam) {
        relevantOptions = Employee.reduce((a, el) => {
            if (el.value !== loggedUserDetail.empID) {
                a.push(el);
            }
            return a;
        }, [Object.assign({}, Employee.find(list => list.value === loggedUserDetail.empID), { label: 'Self', id: loggedUserDetail.userID })]);
    } else {
        relevantOptions = (loggedUserDetail !== null) ? [{ label: `${loggedUserDetail.userName}(Self)`, value: loggedUserDetail.empID, id: loggedUserDetail.userID }].concat(subordinatesListData) : subordinatesListData;
    }
    return {
        loggedUserDetail,
        ingredientCategoryList,
        userPref: state.auth.userPref,
        userPosInfo: state.auth.userPosInfo,
        loading: state.master.loading || state.keyword.loading,
        error: state.master.error || state.keyword.error,
        containerData: state.master.containerData,
        tableLists: state.master.requestAttributeData,
        subordinatesListData,
        Employee,
        EmployeeList: relevantOptions,
        currencyList: currencyList && currencyList || [],
        keywordValuesList,
        metaData: Object.assign({}, {
            "Requested For": relevantOptions,
            "Ingredient": state.keyword.Ingredient || [],
            "Unit": state.keyword.UOM,
            "Menu Item": state.keyword.MenuItem || [],
            "Restaurant": state.keyword.Branch || [],
            "Issue to Store": state.keyword.StorageLocation || [],
            "From Store": state.keyword.StorageLocation || [],
            "Issue From Store": state.keyword.StorageLocation || [],
            "StorageLocation": state.keyword.StorageLocation || [],
            "Uom": state.keyword.UOM || [],
            "Meal Type": state.keyword.resMealPeriod || [],

        })
    }
}


const mapDispatchToProps = dispatch => {
    return {
        getContainerData: (process_Id) => dispatch(actions.getContainerData(process_Id)),
        getMasterKeywordList: (keyword) => dispatch(actions.getMasterKeywordList(keyword)),
        fetchSubordinatesLists: (empId, compId) => dispatch(actions.fetchSubordinatesLists(empId, compId)),
        getKeywordValues: (value) => dispatch(actions.getKeywordValues(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
        getRequestAttributeData: (id) => dispatch(actions.getRequestAttributeData(id)),
        clearCacheStorage: (type, data) => dispatch(actions.clearCacheStorage(type, data))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(AddProductionPlanning);